const InteractionTypes = {
	CALL_TO_ACTION : "call to action",
	UX_ACTION: "ux action"
	}

export default InteractionTypes;



// WEBPACK FOOTER //
// ./src/data/types/InteractionTypes.js